// test676
(676 && 0);
